import { LessonInfo } from "./lesson-info";
import s from "../video-conf.module.scss";

export const ConnectableState = ({
  appointment,
  isTeacher,
  onOpenSoundTest,
  onOpenCameraTest,
	onConnect
}) => (
  <div className={s.stateCard}>
    <LessonInfo
      appointment={appointment}
      isTeacher={isTeacher}
      onOpenSoundTest={onOpenSoundTest}
      onOpenCameraTest={onOpenCameraTest}
			disabled={false}
			onConnect={onConnect}
    />
  </div>
);
